import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Circle, BookOpen, ChevronRight } from "lucide-react";
import api from "@/lib/api";

export default function Learn() {
  const [tracks, setTracks] = useState([]);
  const [open, setOpen] = useState(null);
  const navigate = useNavigate();

  useEffect(() => { api.get("/lessons").then((r) => { setTracks(r.data.tracks); setOpen(r.data.tracks[0]?.id); }); }, []);

  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-5xl mx-auto space-y-5">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight">Knowledge Library</h1>
        <p className="text-tc-sub mt-1">Your reference library. Twelve tracks from market foundations to advanced crypto analysis — explore any concept anytime. Your main progression lives in <span className="text-tc-coach">Training</span>.</p>
      </div>
      <div className="space-y-3">
        {tracks.map((t) => {
          const done = t.lessons.filter((l) => l.completed).length;
          const isOpen = open === t.id;
          return (
            <div key={t.id} className="tc-card overflow-hidden" data-testid={`track-${t.id}`}>
              <button onClick={() => setOpen(isOpen ? null : t.id)} className="w-full flex items-center justify-between p-4 hover:bg-white/5">
                <div className="flex items-center gap-3">
                  <span className="w-8 h-8 rounded-lg bg-tc-mastery/15 border border-tc-mastery/30 text-tc-mastery flex items-center justify-center font-mono text-sm">{t.id}</span>
                  <div className="text-left">
                    <div className="font-heading font-semibold">{t.name}</div>
                    <div className="text-[11px] font-mono text-tc-muted">{done}/{t.lessons.length} complete</div>
                  </div>
                </div>
                <ChevronRight className={`w-5 h-5 text-tc-muted transition-transform ${isOpen ? "rotate-90" : ""}`} />
              </button>
              {isOpen && (
                <div className="border-t border-white/10 divide-y divide-white/5">
                  {t.lessons.map((l) => (
                    <button key={l.id} data-testid={`lesson-${l.id}`} onClick={() => navigate(`/learn/${l.id}`)}
                      className="w-full flex items-center gap-3 p-4 hover:bg-white/5 text-left">
                      {l.completed ? <CheckCircle2 className="w-5 h-5 text-tc-bull shrink-0" /> : <Circle className="w-5 h-5 text-tc-muted shrink-0" />}
                      <div className="flex-1">
                        <div className="text-sm font-medium">{l.title}</div>
                        <div className="text-[12px] text-tc-muted line-clamp-1">{l.why_this_matters}</div>
                      </div>
                      <BookOpen className="w-4 h-4 text-tc-coach" />
                    </button>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
